import BonusPoints from './BonusPoints';
export default BonusPoints;
